import { Box, CircularProgress } from "@mui/material";

import variables from "../../../assets/styles/_variables.module.scss";
import { Spinner } from "../Spinner";

/**
 * Component to render spinner icon or children when data is loading
 */
interface ILoadingWrapper {
    /**
     * Condition to render the loader
     */
    loading: boolean;
    children: string | JSX.Element | JSX.Element[];
    /**
     * Apply style based on type.
     * violet-circle.
     */
    type?: "default" | "loading-page" | "violet-circle";
}

const LoadingWrapper = ({ loading, children, type = "default" }: ILoadingWrapper) => {
    const styles = {
        default: {},
        "loading-page": { display: "flex", width: "100%", justifyContent: "center", marginTop: "2rem" },
    };

    if (!loading) {
        return <>{children}</>;
    }

    if (type === "violet-circle") {
        return (
            <Box
                sx={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    minHeight: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress sx={{ color: variables["primary-purple"] }} />
            </Box>
        );
    }

    return (
        <div style={styles[type]}>
            <Spinner />
        </div>
    );
};

export default LoadingWrapper;
